import { createSelector } from 'reselect'

export const getAvatar = (state, props) => {
  return state.kanbo.userAvatars[props.profileKey]
}

export default () => createSelector(
  [
    getAvatar
  ],
  (
    avatar
  ) => (avatar ? {
    avatar,
  } : {})
)
